import ProductCatalog from '@/pages/home/components/ProductCatalog';
import CatalogSlider from '@/pages/catalogo/components/CatalogSlider';

export default function Catalogo() {
  return (
    <main className="min-h-screen bg-neutral-950">
      <ProductCatalog />
      <CatalogSlider />
    </main>
  );
}